import { useQuery } from '@tanstack/react-query';
import { getTrendingSearches } from '../../../../api/trendingSearches';

interface TrendingSearches {
    formatted: string;
    score: number;
    term: string;
}

const useTrendingSearchQuery = (locationSlug: string) => {
    const timeframe = 'week';

    return useQuery(
        ['search-takeover', locationSlug],
        () => {
            return getTrendingSearches(locationSlug, timeframe).catch(() => ({
                trending: {
                    active_timeframe: '',
                    trending_searches: [],
                },
            }));
        },
        { enabled: !!locationSlug },
    );
};

export const useTrendingSearches = (locationSlug: string) => {
    const { data } = useTrendingSearchQuery(locationSlug);
    return data?.trending.trending_searches as TrendingSearches[];
};
